import './ProjectDetailsHeader.scss';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { Route } from 'react-router-dom';
import { ColumnLayout } from '../../../../modules/common/layouts/columnLayout/ColumnLayout';
import { RowLayout } from '../../../../modules/common/layouts/rowLayout/RowLayout';
import { TRAINING_VARIANT } from '../../../../modules/jobs/jobs.model';
import { ImportAnnotationsView } from '../../../../modules/projects/details/images/importAnnotations/ui/ImportAnnotations.view';
import { EnableFor } from '../../../containers/EnableForRole';
import { InputStatus } from '../../../models/error.model';
import { Home } from '../../../routes/config/Home';
import { ProjectStatus } from '../../projects/projects.model';
import { useProjectPermissions } from '../../projects/projects.permissions';
import { GlobalValidationErrorsContainer } from '../containers/GlobalValidationErrors.container';
import { useProjectDetailsPermissions } from '../projectDetails.permissions';
import { DraftButtons } from './DraftButtons';
import { ProjectHeaderForm } from './ProjectHeaderForm';
import { ProjectInfo } from './ProjectInfo';

interface IProps {
  id: string;
  createdDate: string | null;
  createdBy: string | null;
  modelVariant: TRAINING_VARIANT | null;
  name: string;
  description: string;
  onNameChange: (value: string) => void;
  onDescriptionChange: (value: string) => void;
  onNameBlur: () => Promise<void>;
  onDescriptionBlur: () => Promise<void>;
  nameMaxLength: number;
  nameStatus: InputStatus;
  descriptionMaxLength: number;
  descriptionStatus: InputStatus;
  projectStatus: ProjectStatus;
}

export const ProjectDetailsHeader = observer((props: IProps): ReactElement => {
  const projectDetailsPermissions = useProjectDetailsPermissions();
  const projectsPermissions = useProjectPermissions();

  return (
    <div className='project-details-header'>
      <RowLayout
        size='md'
        spread
      >
        <ColumnLayout
          size='md'
          className='project-details-form'
        >
          <ProjectHeaderForm
            name={props.name}
            onNameChange={props.onNameChange}
            onNameBlur={props.onNameBlur}
            nameMaxLength={props.nameMaxLength}
            nameStatus={props.nameStatus}
            description={props.description}
            onDescriptionChange={props.onDescriptionChange}
            onDescriptionBlur={props.onDescriptionBlur}
            descriptionMaxLength={props.descriptionMaxLength}
            descriptionStatus={props.descriptionStatus}
            projectStatus={props.projectStatus}
          />
          <GlobalValidationErrorsContainer />
        </ColumnLayout>
        <ProjectInfo
          createdDate={props.createdDate}
          createdBy={props.createdBy}
          modelVariant={props.modelVariant}
        />
        <div className='project-details-actions-container'>
          <EnableFor
            hasPermission={projectsPermissions.canSeePublish()}
            hideWhenNoAccess
          >
            <DraftButtons />
          </EnableFor>
          <EnableFor hasPermission={projectDetailsPermissions.canImportAnnotations()}>
            <Route path={Home.Projects.Details.Images.Path}>
              <ImportAnnotationsView />
            </Route>
          </EnableFor>
        </div>
      </RowLayout>
    </div>
  );
});
